import Vue from 'vue';

Vue.filter('plural', function (nb, singular, plural) {
    if (nb > 1) {
        return plural;
    } else {
        return singular;
    }
});
